import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FiRefreshCw, FiBook, FiBookOpen, FiAlertCircle, FiCheckCircle, FiPlus, FiEdit2, FiTrash2, FiChevronDown, FiChevronUp, FiList } from 'react-icons/fi';
import './Kurikulum.css';

// Mapping ID Prodi berdasarkan route
const PRODI_MAP = {
  'profesi-ners': {
    id: '0cd363ea-503f-4468-9f16-b6163b3bdd99', // Profesi Ners dari NEO Feeder
    nama: 'Profesi Ners'
  },
  's1-keperawatan': {
    id: 'ac552e5c-3a71-41d6-9183-344412821873', // Ilmu Keperawatan dari NEO Feeder
    nama: 'S1 Keperawatan'
  },
  's1-kesehatan-masyarakat': {
    id: '509e3f38-e7f7-4319-8529-51b906e79a7b', // Kesehatan Masyarakat dari NEO Feeder
    nama: 'S1 Kesehatan Masyarakat'
  }
};

const Kurikulum = () => {
  const { prodi } = useParams();
  const prodiInfo = PRODI_MAP[prodi];

  const [kurikulums, setKurikulums] = useState([]);
  const [stats, setStats] = useState({
    total_kurikulum: 0,
    total_sks_rata_rata: 0,
    total_sks_tertinggi: 0,
    total_sks_terendah: 0
  });
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [selectedKurikulum, setSelectedKurikulum] = useState(null);
  const [expandedKurikulum, setExpandedKurikulum] = useState(null);
  const [mataKuliahList, setMataKuliahList] = useState([]);
  const [loadingMataKuliah, setLoadingMataKuliah] = useState(false);
  const [showMKAddModal, setShowMKAddModal] = useState(false);
  const [showMKEditModal, setShowMKEditModal] = useState(false);
  const [showMKDeleteModal, setShowMKDeleteModal] = useState(false);
  const [selectedMataKuliah, setSelectedMataKuliah] = useState(null);
  const [mkFormData, setMkFormData] = useState({
    kode_mk: '',
    nama_mk: '',
    sks: '',
    semester: '',
    is_wajib: true,
    sks_tatap_muka: '',
    sks_praktek: '',
    sks_praktek_lapangan: '',
    sks_simulasi: ''
  });
  const [syncConfig, setSyncConfig] = useState({
    limit: 50
  });
  const [formData, setFormData] = useState({
    id_kurikulum: '',
    nama_kurikulum: '',
    semester_mulai_berlaku: '',
    jumlah_sks_lulus: '',
    jumlah_sks_wajib: '',
    jumlah_sks_pilihan: ''
  });
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (prodiInfo) {
      fetchKurikulum();
      fetchStats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prodi]);

  const fetchKurikulum = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`http://localhost:5000/api/kurikulum`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { id_prodi: prodiInfo.id }
      });

      if (response.data.success) {
        setKurikulums(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching kurikulum:', error);
      showAlert('error', 'Gagal mengambil data kurikulum');
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`http://localhost:5000/api/kurikulum/stats`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { id_prodi: prodiInfo.id }
      });

      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const handleSync = async () => {
    try {
      setSyncing(true);
      const token = localStorage.getItem('token');

      const response = await axios.post(
        'http://localhost:5000/api/neofeeder/sync/kurikulum',
        {
          id_prodi: prodiInfo.id,
          limit: syncConfig.limit
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', `Berhasil sinkronisasi ${response.data.data.total} kurikulum`);
        setShowSyncModal(false);
        fetchKurikulum();
        fetchStats();
      } else {
        showAlert('error', response.data.message || 'Sinkronisasi gagal');
      }
    } catch (error) {
      console.error('Error syncing:', error);
      showAlert('error', error.response?.data?.message || 'Gagal melakukan sinkronisasi');
    } finally {
      setSyncing(false);
    }
  };

  const showAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 5000);
  };

  const handleAddKurikulum = async () => {
    try {
      // Validasi form
      if (!formData.id_kurikulum || !formData.nama_kurikulum) {
        showAlert('error', 'ID Kurikulum dan Nama Kurikulum wajib diisi');
        return;
      }

      setSaving(true);
      const token = localStorage.getItem('token');

      const payload = {
        neoFeederId: formData.id_kurikulum,
        id_kurikulum: formData.id_kurikulum,
        nama_kurikulum: formData.nama_kurikulum,
        id_prodi: prodiInfo.id,
        nama_prodi: prodiInfo.nama,
        semester_mulai_berlaku: formData.semester_mulai_berlaku || '',
        jumlah_sks_lulus: parseInt(formData.jumlah_sks_lulus) || 0,
        jumlah_sks_wajib: parseInt(formData.jumlah_sks_wajib) || 0,
        jumlah_sks_pilihan: parseInt(formData.jumlah_sks_pilihan) || 0,
        mata_kuliah: []
      };

      const response = await axios.post(
        'http://localhost:5000/api/kurikulum',
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Kurikulum berhasil ditambahkan');
        setShowAddModal(false);
        resetForm();
        fetchKurikulum();
        fetchStats();
      } else {
        showAlert('error', response.data.message || 'Gagal menambahkan kurikulum');
      }
    } catch (error) {
      console.error('Error adding kurikulum:', error);
      showAlert('error', error.response?.data?.message || 'Gagal menambahkan kurikulum');
    } finally {
      setSaving(false);
    }
  };

  const resetForm = () => {
    setFormData({
      id_kurikulum: '',
      nama_kurikulum: '',
      semester_mulai_berlaku: '',
      jumlah_sks_lulus: '',
      jumlah_sks_wajib: '',
      jumlah_sks_pilihan: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditKurikulum = (kurikulum) => {
    setSelectedKurikulum(kurikulum);
    setFormData({
      id_kurikulum: kurikulum.id_kurikulum,
      nama_kurikulum: kurikulum.nama_kurikulum,
      semester_mulai_berlaku: kurikulum.semester_mulai_berlaku || '',
      jumlah_sks_lulus: kurikulum.jumlah_sks_lulus || '',
      jumlah_sks_wajib: kurikulum.jumlah_sks_wajib || '',
      jumlah_sks_pilihan: kurikulum.jumlah_sks_pilihan || ''
    });
    setShowEditModal(true);
  };

  const handleUpdateKurikulum = async () => {
    try {
      if (!formData.nama_kurikulum) {
        showAlert('error', 'Nama Kurikulum wajib diisi');
        return;
      }

      setSaving(true);
      const token = localStorage.getItem('token');

      const payload = {
        nama_kurikulum: formData.nama_kurikulum,
        semester_mulai_berlaku: formData.semester_mulai_berlaku || '',
        jumlah_sks_lulus: parseInt(formData.jumlah_sks_lulus) || 0,
        jumlah_sks_wajib: parseInt(formData.jumlah_sks_wajib) || 0,
        jumlah_sks_pilihan: parseInt(formData.jumlah_sks_pilihan) || 0
      };

      const response = await axios.put(
        `http://localhost:5000/api/kurikulum/${selectedKurikulum._id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Kurikulum berhasil diupdate');
        setShowEditModal(false);
        setSelectedKurikulum(null);
        resetForm();
        fetchKurikulum();
        fetchStats();
      } else {
        showAlert('error', response.data.message || 'Gagal mengupdate kurikulum');
      }
    } catch (error) {
      console.error('Error updating kurikulum:', error);
      showAlert('error', error.response?.data?.message || 'Gagal mengupdate kurikulum');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteClick = (kurikulum) => {
    setSelectedKurikulum(kurikulum);
    setShowDeleteModal(true);
  };

  const handleDeleteKurikulum = async () => {
    try {
      setDeleting(true);
      const token = localStorage.getItem('token');

      const response = await axios.delete(
        `http://localhost:5000/api/kurikulum/${selectedKurikulum._id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Kurikulum berhasil dihapus');
        setShowDeleteModal(false);
        setSelectedKurikulum(null);
        fetchKurikulum();
        fetchStats();
      } else {
        showAlert('error', response.data.message || 'Gagal menghapus kurikulum');
      }
    } catch (error) {
      console.error('Error deleting kurikulum:', error);
      showAlert('error', error.response?.data?.message || 'Gagal menghapus kurikulum');
    } finally {
      setDeleting(false);
    }
  };

  const handleToggleMataKuliah = async (kurikulumId) => {
    if (expandedKurikulum === kurikulumId) {
      // Collapse
      setExpandedKurikulum(null);
      setMataKuliahList([]);
    } else {
      // Expand and fetch mata kuliah
      setExpandedKurikulum(kurikulumId);
      await fetchMataKuliah(kurikulumId);
    }
  };

  const fetchMataKuliah = async (kurikulumId) => {
    try {
      setLoadingMataKuliah(true);
      const kurikulum = kurikulums.find(k => k._id === kurikulumId);
      
      if (kurikulum && kurikulum.mata_kuliah && kurikulum.mata_kuliah.length > 0) {
        setMataKuliahList(kurikulum.mata_kuliah);
      } else {
        setMataKuliahList([]);
      }
    } catch (error) {
      console.error('Error fetching mata kuliah:', error);
      showAlert('error', 'Gagal mengambil data mata kuliah');
    } finally {
      setLoadingMataKuliah(false);
    }
  };

  // Mata Kuliah CRUD Functions
  const handleAddMataKuliah = () => {
    setMkFormData({
      kode_mk: '',
      nama_mk: '',
      sks: '',
      semester: '',
      is_wajib: true,
      sks_tatap_muka: '',
      sks_praktek: '',
      sks_praktek_lapangan: '',
      sks_simulasi: ''
    });
    setShowMKAddModal(true);
  };

  const handleSaveMataKuliah = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      const kurikulum = kurikulums.find(k => k._id === expandedKurikulum);
      const updatedMataKuliah = [...(kurikulum.mata_kuliah || []), {
        ...mkFormData,
        sks: parseInt(mkFormData.sks) || 0,
        semester: parseInt(mkFormData.semester) || 0,
        sks_tatap_muka: parseInt(mkFormData.sks_tatap_muka) || 0,
        sks_praktek: parseInt(mkFormData.sks_praktek) || 0,
        sks_praktek_lapangan: parseInt(mkFormData.sks_praktek_lapangan) || 0,
        sks_simulasi: parseInt(mkFormData.sks_simulasi) || 0
      }];

      const response = await axios.put(
        `http://localhost:5000/api/kurikulum/${expandedKurikulum}`,
        { mata_kuliah: updatedMataKuliah },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Mata kuliah berhasil ditambahkan');
        setShowMKAddModal(false);
        await fetchKurikulum();
        await fetchMataKuliah(expandedKurikulum);
      }
    } catch (error) {
      console.error('Error saving mata kuliah:', error);
      showAlert('error', error.response?.data?.message || 'Gagal menambahkan mata kuliah');
    } finally {
      setSaving(false);
    }
  };

  const handleEditMataKuliah = (mk, index) => {
    setSelectedMataKuliah({ ...mk, index });
    setMkFormData({
      kode_mk: mk.kode_mk || '',
      nama_mk: mk.nama_mk || '',
      sks: mk.sks || '',
      semester: mk.semester || '',
      is_wajib: mk.is_wajib !== undefined ? mk.is_wajib : true,
      sks_tatap_muka: mk.sks_tatap_muka || '',
      sks_praktek: mk.sks_praktek || '',
      sks_praktek_lapangan: mk.sks_praktek_lapangan || '',
      sks_simulasi: mk.sks_simulasi || ''
    });
    setShowMKEditModal(true);
  };

  const handleUpdateMataKuliah = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      const kurikulum = kurikulums.find(k => k._id === expandedKurikulum);
      const updatedMataKuliah = [...(kurikulum.mata_kuliah || [])];
      updatedMataKuliah[selectedMataKuliah.index] = {
        ...mkFormData,
        sks: parseInt(mkFormData.sks) || 0,
        semester: parseInt(mkFormData.semester) || 0,
        sks_tatap_muka: parseInt(mkFormData.sks_tatap_muka) || 0,
        sks_praktek: parseInt(mkFormData.sks_praktek) || 0,
        sks_praktek_lapangan: parseInt(mkFormData.sks_praktek_lapangan) || 0,
        sks_simulasi: parseInt(mkFormData.sks_simulasi) || 0
      };

      const response = await axios.put(
        `http://localhost:5000/api/kurikulum/${expandedKurikulum}`,
        { mata_kuliah: updatedMataKuliah },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Mata kuliah berhasil diperbarui');
        setShowMKEditModal(false);
        setSelectedMataKuliah(null);
        await fetchKurikulum();
        await fetchMataKuliah(expandedKurikulum);
      }
    } catch (error) {
      console.error('Error updating mata kuliah:', error);
      showAlert('error', error.response?.data?.message || 'Gagal memperbarui mata kuliah');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteMKClick = (mk, index) => {
    setSelectedMataKuliah({ ...mk, index });
    setShowMKDeleteModal(true);
  };

  const handleDeleteMataKuliah = async () => {
    try {
      setDeleting(true);
      const token = localStorage.getItem('token');
      
      const kurikulum = kurikulums.find(k => k._id === expandedKurikulum);
      const updatedMataKuliah = [...(kurikulum.mata_kuliah || [])];
      updatedMataKuliah.splice(selectedMataKuliah.index, 1);

      const response = await axios.put(
        `http://localhost:5000/api/kurikulum/${expandedKurikulum}`,
        { mata_kuliah: updatedMataKuliah },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Mata kuliah berhasil dihapus');
        setShowMKDeleteModal(false);
        setSelectedMataKuliah(null);
        await fetchKurikulum();
        await fetchMataKuliah(expandedKurikulum);
      }
    } catch (error) {
      console.error('Error deleting mata kuliah:', error);
      showAlert('error', error.response?.data?.message || 'Gagal menghapus mata kuliah');
    } finally {
      setDeleting(false);
    }
  };

  if (!prodiInfo) {
    return (
      <div className="kurikulum-container">
        <div className="empty-state">
          <FiAlertCircle />
          <p>Program studi tidak ditemukan</p>
        </div>
      </div>
    );
  }

  return (
    <div className="kurikulum-container">
      {/* Header */}
      <div className="kurikulum-header">
        <h2>Kurikulum {prodiInfo.nama}</h2>
        <div className="header-actions">
          <button
            className="btn-add"
            onClick={() => setShowAddModal(true)}
          >
            <FiPlus />
            Tambah Kurikulum
          </button>
          <button
            className="btn-sync"
            onClick={() => setShowSyncModal(true)}
            disabled={syncing}
          >
            <FiRefreshCw className={syncing ? 'rotating' : ''} />
            {syncing ? 'Menyinkronkan...' : 'Sinkronisasi'}
          </button>
        </div>
      </div>

      {/* Alert */}
      {alert && (
        <div className={`alert alert-${alert.type}`}>
          {alert.type === 'success' ? <FiCheckCircle /> : <FiAlertCircle />}
          <span>{alert.message}</span>
        </div>
      )}

      {/* Statistics */}
      <div className="kurikulum-stats">
        <div className="stat-card primary">
          <div className="stat-value">{stats.total_kurikulum}</div>
          <div className="stat-label">Total Kurikulum</div>
        </div>
        <div className="stat-card success">
          <div className="stat-value">{stats.total_sks_rata_rata}</div>
          <div className="stat-label">SKS Rata-rata</div>
        </div>
        <div className="stat-card warning">
          <div className="stat-value">{stats.total_sks_tertinggi}</div>
          <div className="stat-label">SKS Tertinggi</div>
        </div>
        <div className="stat-card info">
          <div className="stat-value">{stats.total_sks_terendah}</div>
          <div className="stat-label">SKS Terendah</div>
        </div>
      </div>

      {/* Table */}
      <div className="kurikulum-table-container">
        <div className="table-header">
          <h3>Daftar Kurikulum</h3>
        </div>

        {loading ? (
          <div className="loading">
            <p>Memuat data kurikulum...</p>
          </div>
        ) : kurikulums.length === 0 ? (
          <div className="empty-state">
            <FiBook />
            <p>Belum ada data kurikulum</p>
            <small>Klik tombol Sinkronisasi untuk mengambil data dari NEO Feeder</small>
          </div>
        ) : (
          <table className="kurikulum-table">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Kurikulum</th>
                <th>SKS Lulus</th>
                <th>SKS Wajib</th>
                <th>SKS Pilihan</th>
                <th>Semester Berlaku</th>
                <th>Terakhir Disinkronkan</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {kurikulums.map((kurikulum, index) => (
                <React.Fragment key={kurikulum._id}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FiBookOpen style={{ color: '#667eea' }} />
                        <strong>{kurikulum.nama_kurikulum}</strong>
                      </div>
                    </td>
                    <td><strong>{kurikulum.jumlah_sks_lulus || 0}</strong> SKS</td>
                    <td>{kurikulum.jumlah_sks_wajib || 0} SKS</td>
                    <td>{kurikulum.jumlah_sks_pilihan || 0} SKS</td>
                    <td>
                      {kurikulum.semester_mulai_berlaku ? (
                        <span className="badge semester">{kurikulum.semester_mulai_berlaku}</span>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>
                      {kurikulum.lastSyncAt
                        ? new Date(kurikulum.lastSyncAt).toLocaleString('id-ID')
                        : '-'}
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-action btn-view-matkul"
                          onClick={() => handleToggleMataKuliah(kurikulum._id)}
                          title={expandedKurikulum === kurikulum._id ? "Sembunyikan Mata Kuliah" : "Lihat Mata Kuliah"}
                        >
                          {expandedKurikulum === kurikulum._id ? <FiChevronUp /> : <FiChevronDown />}
                          <span style={{ marginLeft: '4px', fontSize: '12px' }}>
                            {kurikulum.mata_kuliah?.length || 0} MK
                          </span>
                        </button>
                        <button
                          className="btn-action btn-edit"
                          onClick={() => handleEditKurikulum(kurikulum)}
                          title="Edit Kurikulum"
                        >
                          <FiEdit2 />
                        </button>
                        <button
                          className="btn-action btn-delete"
                          onClick={() => handleDeleteClick(kurikulum)}
                          title="Hapus Kurikulum"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>
                  {/* Mata Kuliah Dropdown Row */}
                  {expandedKurikulum === kurikulum._id && (
                    <tr className="mata-kuliah-row">
                      <td colSpan="8">
                        <div className="mata-kuliah-container">
                        <div className="mata-kuliah-header">
                          <div className="mk-header-left">
                            <FiList style={{ marginRight: '8px' }} />
                            <h4>Daftar Mata Kuliah - {kurikulum.nama_kurikulum}</h4>
                          </div>
                          <button 
                            className="btn btn-primary btn-sm"
                            onClick={handleAddMataKuliah}
                          >
                            <FiPlus style={{ marginRight: '5px' }} />
                            Tambah Mata Kuliah
                          </button>
                        </div>
                        {loadingMataKuliah ? (
                          <div className="mata-kuliah-loading">
                            <p>Memuat data mata kuliah...</p>
                          </div>
                        ) : mataKuliahList.length === 0 ? (
                          <div className="mata-kuliah-empty">
                            <FiBook style={{ fontSize: '32px', color: '#bdc3c7', marginBottom: '10px' }} />
                            <p>Belum ada mata kuliah untuk kurikulum ini</p>
                            <small>Mata kuliah akan otomatis terisi saat sinkronisasi dari NEO Feeder</small>
                          </div>
                        ) : (
                          <div className="mata-kuliah-grid">
                            {mataKuliahList.map((mk, idx) => (
                              <div key={idx} className="mata-kuliah-card">
                                <div className="mk-header">
                                  <span className="mk-semester">Semester {mk.semester || '-'}</span>
                                  {mk.is_wajib ? (
                                    <span className="mk-badge wajib">Wajib</span>
                                  ) : (
                                    <span className="mk-badge pilihan">Pilihan</span>
                                  )}
                                </div>
                                <div className="mk-body">
                                  <p className="mk-kode">{mk.kode_mk || '-'}</p>
                                  <p className="mk-nama">{mk.nama_mk || 'Mata Kuliah'}</p>
                                </div>
                                <div className="mk-footer">
                                  <div className="mk-sks">
                                    <strong>{mk.sks || 0}</strong> SKS
                                  </div>
                                  {(mk.sks_tatap_muka || mk.sks_praktek) && (
                                    <div className="mk-detail">
                                      {mk.sks_tatap_muka > 0 && <span>TM: {mk.sks_tatap_muka}</span>}
                                      {mk.sks_praktek > 0 && <span>PR: {mk.sks_praktek}</span>}
                                      {mk.sks_praktek_lapangan > 0 && <span>PL: {mk.sks_praktek_lapangan}</span>}
                                      {mk.sks_simulasi > 0 && <span>SM: {mk.sks_simulasi}</span>}
                                    </div>
                                  )}
                                </div>
                                <div className="mk-actions">
                                  <button
                                    className="btn-action btn-edit"
                                    onClick={() => handleEditMataKuliah(mk, idx)}
                                    title="Edit Mata Kuliah"
                                  >
                                    <FiEdit2 />
                                  </button>
                                  <button
                                    className="btn-action btn-delete"
                                    onClick={() => handleDeleteMKClick(mk, idx)}
                                    title="Hapus Mata Kuliah"
                                  >
                                    <FiTrash2 />
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Sync Modal */}
      {showSyncModal && (
        <div className="modal-overlay" onClick={() => setShowSyncModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Sinkronisasi Kurikulum</h3>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Program Studi</label>
                <input
                  type="text"
                  value={prodiInfo.nama}
                  disabled
                  style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                />
              </div>
              <div className="form-group">
                <label>Jumlah Data</label>
                <select
                  value={syncConfig.limit}
                  onChange={(e) => setSyncConfig({ ...syncConfig, limit: e.target.value })}
                >
                  <option value="10">10 Data</option>
                  <option value="25">25 Data</option>
                  <option value="50">50 Data</option>
                  <option value="100">100 Data</option>
                  <option value="500">500 Data</option>
                </select>
                <small>Jumlah maksimal data yang akan diambil dari NEO Feeder</small>
              </div>
              <div className="alert alert-info">
                <FiAlertCircle />
                <span>
                  Data kurikulum akan diambil dari NEO Feeder menggunakan fungsi GetListKurikulum
                  untuk program studi {prodiInfo.nama}.
                </span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowSyncModal(false)}
                disabled={syncing}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSync}
                disabled={syncing}
              >
                {syncing ? 'Menyinkronkan...' : 'Mulai Sinkronisasi'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Kurikulum Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Tambah Kurikulum Manual</h3>
              <p className="modal-subtitle">Program Studi: {prodiInfo.nama}</p>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>ID Kurikulum <span className="required">*</span></label>
                  <input
                    type="text"
                    name="id_kurikulum"
                    value={formData.id_kurikulum}
                    onChange={handleInputChange}
                    placeholder="Contoh: KUR-2024-001"
                  />
                  <small>ID unik kurikulum (akan digunakan sebagai neoFeederId)</small>
                </div>
                <div className="form-group">
                  <label>Nama Kurikulum <span className="required">*</span></label>
                  <input
                    type="text"
                    name="nama_kurikulum"
                    value={formData.nama_kurikulum}
                    onChange={handleInputChange}
                    placeholder="Contoh: Kurikulum 2024/2025"
                  />
                  <small>Nama kurikulum yang akan ditampilkan</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Semester Mulai Berlaku</label>
                  <input
                    type="text"
                    name="semester_mulai_berlaku"
                    value={formData.semester_mulai_berlaku}
                    onChange={handleInputChange}
                    placeholder="Contoh: 20241"
                  />
                  <small>Format: YYYYS (tahun + semester: 1=Ganjil, 2=Genap)</small>
                </div>
                <div className="form-group">
                  <label>Jumlah SKS Lulus</label>
                  <input
                    type="number"
                    name="jumlah_sks_lulus"
                    value={formData.jumlah_sks_lulus}
                    onChange={handleInputChange}
                    placeholder="144"
                    min="0"
                  />
                  <small>Total SKS yang harus diselesaikan untuk lulus</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Jumlah SKS Wajib</label>
                  <input
                    type="number"
                    name="jumlah_sks_wajib"
                    value={formData.jumlah_sks_wajib}
                    onChange={handleInputChange}
                    placeholder="120"
                    min="0"
                  />
                  <small>Total SKS mata kuliah wajib</small>
                </div>
                <div className="form-group">
                  <label>Jumlah SKS Pilihan</label>
                  <input
                    type="number"
                    name="jumlah_sks_pilihan"
                    value={formData.jumlah_sks_pilihan}
                    onChange={handleInputChange}
                    placeholder="24"
                    min="0"
                  />
                  <small>Total SKS mata kuliah pilihan</small>
                </div>
              </div>

              <div className="alert alert-info">
                <FiAlertCircle />
                <span>
                  Data kurikulum yang ditambahkan secara manual akan tersimpan di database lokal.
                  Pastikan ID Kurikulum unik dan belum ada di database.
                </span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                disabled={saving}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddKurikulum}
                disabled={saving}
              >
                {saving ? 'Menyimpan...' : 'Simpan Kurikulum'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Kurikulum Modal */}
      {showEditModal && selectedKurikulum && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Edit Kurikulum</h3>
              <p className="modal-subtitle">Program Studi: {prodiInfo.nama}</p>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>ID Kurikulum</label>
                  <input
                    type="text"
                    value={formData.id_kurikulum}
                    disabled
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                  <small>ID tidak dapat diubah</small>
                </div>
                <div className="form-group">
                  <label>Nama Kurikulum <span className="required">*</span></label>
                  <input
                    type="text"
                    name="nama_kurikulum"
                    value={formData.nama_kurikulum}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Semester Mulai Berlaku</label>
                  <input
                    type="text"
                    name="semester_mulai_berlaku"
                    value={formData.semester_mulai_berlaku}
                    onChange={handleInputChange}
                    placeholder="Contoh: 20241"
                  />
                </div>
                <div className="form-group">
                  <label>Jumlah SKS Lulus</label>
                  <input
                    type="number"
                    name="jumlah_sks_lulus"
                    value={formData.jumlah_sks_lulus}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Jumlah SKS Wajib</label>
                  <input
                    type="number"
                    name="jumlah_sks_wajib"
                    value={formData.jumlah_sks_wajib}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Jumlah SKS Pilihan</label>
                  <input
                    type="number"
                    name="jumlah_sks_pilihan"
                    value={formData.jumlah_sks_pilihan}
                    onChange={handleInputChange}
                    min="0"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowEditModal(false);
                  setSelectedKurikulum(null);
                  resetForm();
                }}
                disabled={saving}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateKurikulum}
                disabled={saving}
              >
                {saving ? 'Menyimpan...' : 'Update Kurikulum'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedKurikulum && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Konfirmasi Hapus</h3>
            </div>
            <div className="modal-body">
              <div className="alert alert-error">
                <FiAlertCircle />
                <span>
                  Apakah Anda yakin ingin menghapus kurikulum ini?
                </span>
              </div>
              <div style={{ marginTop: '15px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#7f8c8d' }}>Nama Kurikulum:</p>
                <p style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
                  {selectedKurikulum.nama_kurikulum}
                </p>
              </div>
              <p style={{ marginTop: '15px', fontSize: '13px', color: '#e74c3c' }}>
                <strong>Perhatian:</strong> Tindakan ini tidak dapat dibatalkan!
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedKurikulum(null);
                }}
                disabled={deleting}
              >
                Batal
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDeleteKurikulum}
                disabled={deleting}
              >
                {deleting ? 'Menghapus...' : 'Ya, Hapus'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Mata Kuliah Modal */}
      {showMKAddModal && (
        <div className="modal-overlay" onClick={() => setShowMKAddModal(false)}>
          <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Tambah Mata Kuliah</h3>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Kode Mata Kuliah <span className="required">*</span></label>
                  <input
                    type="text"
                    value={mkFormData.kode_mk}
                    onChange={(e) => setMkFormData({ ...mkFormData, kode_mk: e.target.value })}
                    placeholder="Contoh: MK101"
                  />
                </div>
                <div className="form-group">
                  <label>Nama Mata Kuliah <span className="required">*</span></label>
                  <input
                    type="text"
                    value={mkFormData.nama_mk}
                    onChange={(e) => setMkFormData({ ...mkFormData, nama_mk: e.target.value })}
                    placeholder="Contoh: Algoritma dan Pemrograman"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Total SKS <span className="required">*</span></label>
                  <input
                    type="number"
                    value={mkFormData.sks}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks: e.target.value })}
                    placeholder="3"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Semester <span className="required">*</span></label>
                  <input
                    type="number"
                    value={mkFormData.semester}
                    onChange={(e) => setMkFormData({ ...mkFormData, semester: e.target.value })}
                    placeholder="1"
                    min="1"
                    max="14"
                  />
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select
                    value={mkFormData.is_wajib}
                    onChange={(e) => setMkFormData({ ...mkFormData, is_wajib: e.target.value === 'true' })}
                  >
                    <option value="true">Wajib</option>
                    <option value="false">Pilihan</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>SKS Tatap Muka</label>
                  <input
                    type="number"
                    value={mkFormData.sks_tatap_muka}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_tatap_muka: e.target.value })}
                    placeholder="2"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>SKS Praktek</label>
                  <input
                    type="number"
                    value={mkFormData.sks_praktek}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_praktek: e.target.value })}
                    placeholder="1"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>SKS Praktek Lapangan</label>
                  <input
                    type="number"
                    value={mkFormData.sks_praktek_lapangan}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_praktek_lapangan: e.target.value })}
                    placeholder="0"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>SKS Simulasi</label>
                  <input
                    type="number"
                    value={mkFormData.sks_simulasi}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_simulasi: e.target.value })}
                    placeholder="0"
                    min="0"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowMKAddModal(false)}
                disabled={saving}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSaveMataKuliah}
                disabled={saving}
              >
                {saving ? 'Menyimpan...' : 'Simpan'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Mata Kuliah Modal */}
      {showMKEditModal && selectedMataKuliah && (
        <div className="modal-overlay" onClick={() => setShowMKEditModal(false)}>
          <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Edit Mata Kuliah</h3>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Kode Mata Kuliah <span className="required">*</span></label>
                  <input
                    type="text"
                    value={mkFormData.kode_mk}
                    onChange={(e) => setMkFormData({ ...mkFormData, kode_mk: e.target.value })}
                    placeholder="Contoh: MK101"
                  />
                </div>
                <div className="form-group">
                  <label>Nama Mata Kuliah <span className="required">*</span></label>
                  <input
                    type="text"
                    value={mkFormData.nama_mk}
                    onChange={(e) => setMkFormData({ ...mkFormData, nama_mk: e.target.value })}
                    placeholder="Contoh: Algoritma dan Pemrograman"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Total SKS <span className="required">*</span></label>
                  <input
                    type="number"
                    value={mkFormData.sks}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks: e.target.value })}
                    placeholder="3"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Semester <span className="required">*</span></label>
                  <input
                    type="number"
                    value={mkFormData.semester}
                    onChange={(e) => setMkFormData({ ...mkFormData, semester: e.target.value })}
                    placeholder="1"
                    min="1"
                    max="14"
                  />
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select
                    value={mkFormData.is_wajib}
                    onChange={(e) => setMkFormData({ ...mkFormData, is_wajib: e.target.value === 'true' })}
                  >
                    <option value="true">Wajib</option>
                    <option value="false">Pilihan</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>SKS Tatap Muka</label>
                  <input
                    type="number"
                    value={mkFormData.sks_tatap_muka}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_tatap_muka: e.target.value })}
                    placeholder="2"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>SKS Praktek</label>
                  <input
                    type="number"
                    value={mkFormData.sks_praktek}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_praktek: e.target.value })}
                    placeholder="1"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>SKS Praktek Lapangan</label>
                  <input
                    type="number"
                    value={mkFormData.sks_praktek_lapangan}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_praktek_lapangan: e.target.value })}
                    placeholder="0"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>SKS Simulasi</label>
                  <input
                    type="number"
                    value={mkFormData.sks_simulasi}
                    onChange={(e) => setMkFormData({ ...mkFormData, sks_simulasi: e.target.value })}
                    placeholder="0"
                    min="0"
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowMKEditModal(false);
                  setSelectedMataKuliah(null);
                }}
                disabled={saving}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateMataKuliah}
                disabled={saving}
              >
                {saving ? 'Menyimpan...' : 'Update'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Mata Kuliah Confirmation Modal */}
      {showMKDeleteModal && selectedMataKuliah && (
        <div className="modal-overlay" onClick={() => setShowMKDeleteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Konfirmasi Hapus Mata Kuliah</h3>
            </div>
            <div className="modal-body">
              <div className="alert alert-error">
                <FiAlertCircle />
                <span>
                  Apakah Anda yakin ingin menghapus mata kuliah ini?
                </span>
              </div>
              <div style={{ marginTop: '15px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#7f8c8d' }}>Mata Kuliah:</p>
                <p style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
                  {selectedMataKuliah.kode_mk} - {selectedMataKuliah.nama_mk}
                </p>
                <p style={{ margin: '0', fontSize: '14px', color: '#7f8c8d' }}>
                  {selectedMataKuliah.sks} SKS | Semester {selectedMataKuliah.semester}
                </p>
              </div>
              <p style={{ marginTop: '15px', fontSize: '13px', color: '#e74c3c' }}>
                <strong>Perhatian:</strong> Tindakan ini tidak dapat dibatalkan!
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowMKDeleteModal(false);
                  setSelectedMataKuliah(null);
                }}
                disabled={deleting}
              >
                Batal
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDeleteMataKuliah}
                disabled={deleting}
              >
                {deleting ? 'Menghapus...' : 'Ya, Hapus'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Kurikulum;
